import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-bs-target", "data-bs-slide", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      type: "button",
      "data-bs-target": _ctx.dataBsTarget,
      "data-bs-slide": _ctx.dataBsSlide,
      class: "bg-transparent fs-3 border-0 font-color-grey",
      disabled: _ctx.numSlides === 1,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clicked')))
    }, [
      _createVNode(_component_font_awesome_icon, { icon: "circle-arrow-right" })
    ], 8, _hoisted_1)
  ]))
}